<!--<sh-logs-metadata-query class="metadata-row"></sh-logs-metadata-query>-->
<sh-logs-grid
  style="height: 100%;width: 100%"
  (onGridRowSelected)="rowSelected($event)"
></sh-logs-grid>
